// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  display: flex;
  flex-direction: column;
}

.welcome-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  margin-top: 2rem;
  background-color: var(--background-color);
  color: var(--text-color);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.welcome-content h2 {
  margin-bottom: 1rem;
}

.welcome-content p {
  margin-bottom: 2rem;
  color: var(--text-secondary-color);
}

.welcome-actions {
  display: flex;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/WelcomePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,wBAAwB;EACxB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".auth-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.welcome-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 2rem;\r\n  margin-top: 2rem;\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  max-width: 500px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.welcome-content h2 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.welcome-content p {\r\n  margin-bottom: 2rem;\r\n  color: var(--text-secondary-color);\r\n}\r\n\r\n.welcome-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
